module.exports = __webpack_public_path__ + "static/media/bgwater.fcd5b15d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgwater.gif
// module id = 27
// module chunks = 0